import { render, staticRenderFns } from "./DialogCreateTreinamentoProfessorComponent.vue?vue&type=template&id=2b4c5408&"
import script from "./DialogCreateTreinamentoProfessorComponent.vue?vue&type=script&lang=js&"
export * from "./DialogCreateTreinamentoProfessorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports